export function convertUTCDateToLocalDate(date) {
  const convertedDate = new Date(date);
  const offset = convertedDate.getTimezoneOffset();
  convertedDate.setMinutes(convertedDate.getMinutes() - offset);
  return convertedDate;
}

export function getCurrentDatePlusDays(days) {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date;
}
function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}

export function formatDateToBackendWithHours(date) {
  return (
    `${[
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate())
    ].join('-')
    } ${
      [
        padTo2Digits(date.getHours()),
        padTo2Digits(date.getMinutes()),
        padTo2Digits(date.getSeconds())
      ].join(':')}`
  );
}

export function formatDateToBackendFormat(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    '0'
  )}-${String(date.getDate()).padStart(2, '0')}`;
}

export function formattedDate(date) {
  const dateObj = new Date(date);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
